import CoreUtils from './CoreUtils';

export default class ArrayUtils {
  static areArraysEquivalent(array1, array2) {
    if (CoreUtils.isUndefinedOrNull(array1) && CoreUtils.isUndefinedOrNull(array2))
      return true;

    if (CoreUtils.isUndefinedOrNull(array1) || CoreUtils.isUndefinedOrNull(array2))
      return false;

    if (!Array.isArray(array1) || !Array.isArray(array2))
      return false;

    if (array1.length !== array2.length)
      return false;

    for (var index = 0; index < array1.length; index++) {
      if (array1[index] !== array2[index])
        return false;
    }

    return true;
  }

  static intersectArrays(values1, values2, intersectFunc) {
    if (values1.length !== values2.length)
      return [];

    var intersectValues = [];
    for (var index = 0; index < values1.length; index += 1)
      intersectValues[index] = intersectFunc(values1[index], values2[index]);

    return intersectValues;
  }

  static addElement(array, item) {
    return array.toSpliced(array.length, 0, item);
  }

  static removeElement(array, item) {
    var index = array.indexOf(item);
    if (index === -1)
      return;

    array.splice(index, 1);
  }

  static mapWithParameters(array, callback, ...parameters) {
    if (!Array.isArray(array) || typeof callback !== 'function')
      return [];

    var resultArray = []
    for (var index = 0; index < array.length; index++) {
      resultArray.push(callback(array[index], ...parameters));
    }

    return resultArray;
  }

  static isValidNumber(value) {
    return typeof value === 'number' && !isNaN(value);
  }

  static isValidNumberArray(values) {
    if (values === undefined || values === null || !Array.isArray(values))
      return false;

    for (var index = 0; index < values.length; index++) {
      if (!ArrayUtils.isValidNumber(values[index]))
        return false;
    }

    return true;
  }

  static minimumValue(values, defaultValue) {
    if (!ArrayUtils.isValidNumberArray(values) || values.length === 0)
      return defaultValue;

    var minValue = values[0];
    for (var index = 1; index < values.length; index++)
      minValue = Math.min(minValue, values[index]);

    return minValue;
  }

  static maximumValue(values, defaultValue) {
    if (!ArrayUtils.isValidNumberArray(values) || values.length === 0)
      return defaultValue;

    var maxValue = values[0];
    for (var index = 1; index < values.length; index++)
      maxValue = Math.max(maxValue, values[index]);

    return maxValue;
  }
}